import { forwardRef } from "react"
import { mergeClasses } from "@lib/css"

import type { IconProps } from "./types"

export const IconChevronDown = forwardRef<SVGSVGElement, IconProps>(
  function IconChevronDown(props, ref) {
    const { className, title, titleId, ...otherProps } = props
    const defaultClasses =
      "w-4 h-4 flex-shrink-0 text-black transition-colors duration-150 ease-in focus:outline-none"
    const classes = mergeClasses(defaultClasses, className)

    return (
      <svg
        ref={ref}
        viewBox="0 0 16 16"
        fill="none"
        focusable="false"
        aria-hidden="true"
        tabIndex={-1}
        className={classes}
        aria-labelledby={titleId}
        {...otherProps}
      >
        {title ? <title id={titleId}>{title}</title> : null}
        <path
          d="M1.85037 5.87625L7.85037 11.1763C7.90586 11.2244 7.97688 11.251 8.05037 11.251C8.12386 11.251 8.19489 11.2244 8.25037 11.1763L14.2504 5.87625C14.28 5.85007 14.3042 5.81827 14.3216 5.78269C14.3389 5.74711 14.349 5.70846 14.3513 5.66896C14.3536 5.62945 14.3481 5.58988 14.3351 5.55252C14.3221 5.51515 14.3018 5.48074 14.2754 5.45125C14.2218 5.3925 14.1473 5.357 14.068 5.35233C13.9886 5.34766 13.9105 5.37419 13.8504 5.42625L8.05037 10.5513L2.25037 5.42625C2.19026 5.37419 2.11218 5.34766 2.03279 5.35233C1.9534 5.357 1.87897 5.3925 1.82537 5.45125C1.79898 5.48074 1.77868 5.51515 1.76565 5.55252C1.75261 5.58988 1.7471 5.62945 1.74942 5.66896C1.75174 5.70846 1.76186 5.74711 1.77919 5.78269C1.79651 5.81827 1.8207 5.85006 1.85037 5.87625Z"
          fill="currentColor "
        />
      </svg>
    )
  },
)
